import './navigation.js';
import './skip-link-focus-fix.js'

gsap.registerPlugin(Draggable);
gsap.registerPlugin(ScrollTrigger);

(( $ ) => {


	$(document).ready( () => {

		if ($('.features')) {


			// handling features & their changes
			$('.feature:first-child').addClass('active');
			gsap.set('.feature:first-child', {opacity:1 });
			$('.nav-item:first-child').addClass('active');


			$('.nav-item').click(function() {
				var rel = $(this).attr('rel');
				nextItem('#' + rel, this);

			});
			// change active feature with arrow keys
			$(document).keydown(function(e) {
		    console.log(e.keyCode);
				switch(e.which) {

					case 37: // left
					if ($('.feature.active').is(':first-child')) {
						var prev = $('.feature:last-child');
						var prevNav = $('.nav-item:last-child');
					} else {
						var prev = $('.feature.active').prev();
						var prevNav = $('.nav-item.active').prev();
					}


					nextItem(prev, prevNav);
					break;

					case 39: // right
					if ($('.feature.active').is(':last-child')) {
						var next = $('.feature:first-child');
						var nextNav = $('.nav-item:first-child');
					} else {
						var next = $('.feature.active').next();
						var nextNav = $('.nav-item.active').next();
					}

					nextItem(next, nextNav);
					break;

				default: return; // exit this handler for other keys
				}
				e.preventDefault(); // prevent the default action (scroll / move caret)
			});

			function nextItem(item, nav) {

				$('.nav-item').removeClass('active');
				var tl = new TimelineMax();
				tl.to('.feature',0.25, {opacity:0, ease:Power1.easeInOut, onComplete: $('.feature.active').removeClass('active') });
				tl.to(item,0.4, {opacity:1, ease:Power1.easeInOut,  });
				$(item).addClass('active');

				$(nav).addClass('active');

			}

		}

		// ---------- features ends -------

		//show sections when visible

		var findSections = $('section');

		const sections =  gsap.utils.toArray(findSections);
		sections.forEach((section, i) => {

			gsap.to(section, 0.5, {
				ease:Power1.easeIn,
				opacity: 1,
				y: 0,
				x: 0,
				z: 0,
				scrollTrigger: {
				trigger: section,
				start: 'top bottom-=100px',
			}
			},);
		});

		//trigger number counter on scroll
		var findNumbers = $('.number');
		// acf js api
		// var number = acf.get('post_id');

		const numbers =  gsap.utils.toArray(findNumbers);
		numbers.forEach((number, i) => {

			var sum = $(number).text().trim();
			number.innerHTML = 0;
			var count = {val: 0 } , NewVal = sum ;

			gsap.to(count, 2, {
				val:NewVal,
				roundProps:"val",
				onUpdate: function () {
				count.toLocaleString('fi-FI');
				number.innerHTML = count.val;
			},
			ease: 'none',

			scrollTrigger: {
				trigger: number,
				  start: 'top bottom-=100px',
			}
			},);
			var parent = $(number).parent();
			gsap.to(parent, 0.5, {
				ease: 'none',
				opacity: 1,
				scrollTrigger: {
				trigger: number,
				start: 'top bottom-=50px',
			}
			},);
		});


			// use list Draggable
			// var wrappers = $('.uses-wrapper');
			// const uses =  gsap.utils.toArray(wrappers);
			//   uses.forEach((use, i) => {
			// 		var parent = use.parent();
			// 			Draggable.create(use, {
			// 				type: "x",
			// 				inertia: true,
			// 				bounds: parent,
			// 			});
			// 	});


			$('#menu-toggle').click(function(){
  			$("#site-menu").slideToggle();
				$(this).toggleClass('active');
			});


	});


	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/app.js